"use client";

import { data } from "./data";
import Card from "@/app/[locale]/(unauth)/airport-transfer/components/Card";
import { Input } from "../ui/Input";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { useDebounce } from "@/hooks/useDebounce";
import useSWR from "swr";
import { getATPosts } from "actions/content";

function TopCities(props: { take?: number; sort?: "OLDEST" | "NEWEST" }) {
  const t = useTranslations("Index");
  const { take = 8, sort = "NEWEST" } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  // Only include searchText in the key when there's actually a search term
  const swrKey = debouncedSearchTerm
    ? "/api/content/at-posts" + debouncedSearchTerm + sort + take + `&onlyPublic=true`
    : null;

  // Fetcher function that matches the key logic
  const fetcher = () => {
    if (debouncedSearchTerm) {
      return getATPosts({ take, searchText: debouncedSearchTerm, sort, onlyPublic: true, page: 1 });
    } else {
      return null; // Return null if no search term, so SWR won't fetch
    }
  };

  const atposts = useSWR(
    swrKey,
    fetcher,
    {
      keepPreviousData: true,
      refreshInterval: 5000,
    }
  );

  const isLoading = atposts.isLoading;

  return (
    <div className='w-full flex flex-col items-start space-y-[24px] '>
      <div className="flex flex-col lg:flex-row items-start gap-y-2 lg:items-center justify-between w-full px-[24px] xl:px-[24px]">
        <h4 className='font-degular-display-semibold text-[24px] lg:text-[32px] !leading-none'>{t('top_cities.title')}</h4>
        <Input
          placeholder={"Search..."}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-[300px] lg:w-[400px]"
        />
      </div>
      <div className='w-full max-w-[100vw]'>
        <div className='flex flex-row xl:grid grid-cols-4 gap-[24px] overflow-x-scroll no-scrollbar px-[24px] xl:px-[24px]'>
          {isLoading ?
            <>
              {
                [1, 2, 3, 4].map(() => {
                  return (
                    <div className="min-w-[256px]">
                      <Card isLoading continent="" desc="" />
                    </div>
                  )
                })
              }
            </> :
            atposts.data && (atposts.data.results.length !== 0) ?
              atposts.data?.results.map((post, index) => {
                return (
                  <div className="min-w-[256px]">
                    <Card
                      {...post}
                      key={post.id + "/" + index}
                      thumbnail={post.thumbnail}
                      title={post.content?.contentByLangs[0]?.title}
                      desc={post.content?.contentByLangs[0]?.desc ?? ""}
                      // @ts-ignore
                      contentByLangs={post.content?.contentByLangs}
                    />
                  </div>
                )
              })
              : !!searchTerm
                ? <div className="w-full bg-[#F6F6F6] rounded-[32px] min-h-56 flex items-center justify-center col-span-4">
                  <p className="text-center text-[16px] font-semibold py-4">{t('top_cities.no_results')}</p>
                </div>
                : (data.map((item, index) => {
                  return (
                    <div className="min-w-[256px]">
                      <Card
                        key={item.title + "/" + index}
                        {...item}
                      />
                    </div>
                  )
                }))}
        </div>
      </div>
    </div>
  )
}

export default TopCities
